import {ICorporationNumberSettings} from '../api-response/sms-notification';

export class SettingsSms {
    static fromCorporationNumberSettings(settings: ICorporationNumberSettings): SettingsSms {
        return new SettingsSms(
            settings.id,
            settings.corporationNumberId,
            undefined,
            settings.twilioSettings,
            settings.createdAt,
            settings.isEnable
        );
    }

    constructor(
        public id: string = '',
        public corporationNumberId: number = null,
        public corporationNumberName: string = '',
        public twilioSettings: any = null,
        public createdAt: string = '',
        public isEnable: boolean = false
    ) {
    }
}



// WEBPACK FOOTER //
// /app/src/app/types/models/SettingsSms.ts